import * as angular from 'angular';
import EnvironmentName, { Environment } from "../../shared/config/environment";

export interface TransformCallback {
  (input: any): any;
}

export interface HttpService {
  all<T>(requests: angular.IPromise<any>[]): angular.IPromise<T>;
  get<T>(endpoint: string, params?: any, transformCallback?: TransformCallback): angular.IPromise<T>;
  post<T>(endpoint: string, data?: any, transformCallback?: TransformCallback): angular.IPromise<T>;
  postRequest<T>(endpoint: string, request: angular.IRequestShortcutConfig): angular.IPromise<T>;
  put<T>(endpoint: string, data?: any, transformCallback?: TransformCallback): angular.IPromise<T>;
  delete<T>(endpoint: string, params?: any, transformCallback?: TransformCallback): angular.IPromise<T>;
  getUrl(endpoint: string): string;
}

class HttpSvc implements HttpService {
  private $http: angular.IHttpService;
  private $q: angular.IQService;
  private environment: Environment;

  constructor(
    $http: angular.IHttpService,
    $q: angular.IQService,
    environment: Environment) {
    this.$http = $http;
    this.$q = $q;
    this.environment = environment;
  }

  private http<T>(
    method: string,
    endpoint: string,
    request: any,
    params: any,
    transformCallback: TransformCallback) {
    let defer = this.$q.defer<T>();

    endpoint = this.getUrl(endpoint);

    this.$http<T>({
      method: method,
      params: params,
      data: request,
      url: endpoint,
      transformResponse: transformCallback || this.$http.defaults.transformResponse
    }).then((response) => defer.resolve(response.data),
      (response) => defer.reject(response));

    return defer.promise;
  }

  private httpRequest<T>(
    method: string,
    endpoint: string,
    request: angular.IRequestShortcutConfig) {
    let defer = this.$q.defer<T>();

    endpoint = this.getUrl(endpoint);

    this.$http<T>({
      method: method,
      url: endpoint,
      ...request
    }).then((response) => defer.resolve(response.data),
      (response) => defer.reject(response));

    return defer.promise;
  }

  all<T>(requests: angular.IPromise<any>[]): angular.IPromise<T> {
    let defer = this.$q.defer();

    this.$q.all(requests)
      .then((response) => defer.resolve(response),
        (response) => defer.reject(response));

    return defer.promise as angular.IPromise<T>;
  }

  get<T>(endpoint: string, params?: any, transformCallback?: TransformCallback): angular.IPromise<T> {
    return this.http<T>('GET', endpoint, null, params, transformCallback);
  }

  post<T>(endpoint: string, data?: any, transformCallback?: TransformCallback): angular.IPromise<T> {
    return this.http<T>('POST', endpoint, data, null, transformCallback);
  }

  postRequest<T>(endpoint: string, request: angular.IRequestShortcutConfig): angular.IPromise<T> {
    return this.httpRequest<T>('POST', endpoint, request);
  }

  put<T>(endpoint: string, data?: any, transformCallback?: TransformCallback): angular.IPromise<T> {
    return this.http<T>('PUT', endpoint, data, null, transformCallback);
  }

  delete<T>(endpoint: string, params?: any, transformCallback?: TransformCallback): angular.IPromise<T> {
    return this.http<T>('DELETE', endpoint, null, params, transformCallback);
  }

  getUrl(endpoint: string): string {
    if (endpoint.indexOf('http') !== 0) {
      return this.environment.API_PATH + endpoint;
    }
    return endpoint;
  }
}

export default angular.module('aps.services.http', [EnvironmentName])
  .service('httpService', HttpSvc)
  .name;



// WEBPACK FOOTER //
// ./src/app/services/http/http.service.ts